module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_bg_up.1788921444950.png";